import { render, staticRenderFns } from "./RichTextLayout.vue?vue&type=template&id=2f7df7e2&"
import script from "./RichTextLayout.vue?vue&type=script&lang=js&"
export * from "./RichTextLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports